module.exports = __webpack_public_path__ + "static/media/RS.46192e2d.wav";